var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.cookieData)?_c('div',[_c('h1',[_vm._v(_vm._s(_vm.cookieData.Headline))]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.cookieData.LongDescription)}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }